import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  root: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 16px 0px;
  `,
  labels: css`
    display: flex;
    align-items: center;
    gap: 8px;
  `,
  label: ({ theme }) => css`
    font-size: ${theme.fonts.heading[5].fontSize}px;
    font-weight: ${theme.fonts.heading[5].fontWeight};
  `,
  unreadConversationsAmount: ({ theme }) => css`
    background-color: ${theme.colors.neutral.gray[70]};
    height: 19px;
    width: 19px;
    border-radius: 30px;
    position: relative;
  `,
  amount: css`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  `,
  loader: css`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
